import { getCurrentUserToken } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "reactfire";
import { getUserBillingDetail } from "../../handlers/getUserBillingDetail";

export const USER_BILLING_DETAIL_QUERY_KEY = "user-billing-detail";

export const useGetUserBillingDetailQuery = () => {
  const auth = useAuth();

  return useQuery({
    queryKey: [USER_BILLING_DETAIL_QUERY_KEY, auth.currentUser?.uid],
    queryFn: async () => {
      const token = await getCurrentUserToken();
      if (!token) {
        throw new Error("No authentication token");
      }

      const response = await getUserBillingDetail({ token });
      return response.data;
    },
    enabled: !!auth.currentUser?.uid,
    staleTime: 0,
    retry: 2,
    refetchOnWindowFocus: true,
  });
};
